<template>
  <div>
    
    <div class="information">
      <strong>Accommodation images schould meet the following requirements:</strong>
      <ul>
        <li>Should be a <strong>.jpg file</strong> format</li>
        <li>Should have a minimum <strong>width of 2048px</strong></li>
        <li>Should have a minimum <strong>height of 1536px</strong></li>
        <li>The aspect ratio should be <strong>4:3</strong></li>
        <li>The image should be <strong>unique</strong> and not be used on any other accommodation</li>
      </ul>
    </div>
    <div class="importantinformation">
      <strong>Warning:</strong> Images are being processed in the background. They will not be visible immediately after uploading. Please wait for the processing to complete. You can view processing errors by clicking on the "Upload errors" button
    </div>
    <div id="dropzone" class="dropzone"></div>
    <!-- <vue-dropzone ref="hsftDropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-sending="sendingEvent" @vdropzone-complete="completeEvent" @vdropzone-thumbnail="thumbnailEvent"></vue-dropzone> -->
</div>
  
</template>
<script>
import Dropzone from 'dropzone'
import 'dropzone/dist/dropzone.css'

export default {
    name: 'HsftDropzone',
    props:{
    huisRowId: {
      type: String,
      required: true
    },
    huisNr: {
      type: Number,
      required: false,
      default: 1
    },
    gebrEncrid: {
      type: String,
      required: false,
      default: ''
    },
    uploadUrl: {
      type: String,
      required: false,
      default: '/php/upload.php'
    }
  },
    mounted() {
        let myDropzone = new Dropzone("#dropzone", {
            url: this.uploadUrl, // URL to your PHP upload handler dev: /php/upload.php
            thumbnailWidth: 150,
            thumbnailHeight: 150,
            acceptedFiles: 'image/jpeg',
            maxFilesize: 1000,
            dictDefaultMessage: 'Drop one or more accommodation image(s) here or click here to select <br> <strong>Do not forget to tag the images after uploading and processing is complete</strong>',
            parallelUploads: 5,
            autoProcessQueue: true,
            maxThumbnailFilesize: 40,
            timeout: 0
        });
        myDropzone.on("sending", (file, xhr, formData) => {
            formData.append('token', this.$session.get("ARES"))
            formData.append('clientSessionId', this.$session.id())
            formData.append('huis_encrid', this.huisRowId)
            formData.append('huis_nr', this.huisNr)
            formData.append('gebr_encrid', this.gebrEncrid)
        });
        myDropzone.on("complete", (file) => {
            const response = JSON.parse(file.xhr.response) // Parse response from addHsftDropZone.p
            if(response.addHsft.error){ // If response has error
                file.previewElement.classList.remove("dz-success") // Remove success styling from preview element
                file.previewElement.classList.add("dz-error") // Add error styling to preview element
                file.previewElement.childNodes[7].children[0].innerHTML = response.addHsft.message // Set error message in preview element
            }
        });
        myDropzone.on("error", (file) => {
            console.log('on error: Error uploading image: ' + file.xhr.response);
            console.log(file);

        });

    }
}

</script>
<style>

.information{
  background-color: #d9f1ff;
  border: 1px solid #98cfff;
  padding: 10px;
  margin-bottom: 10px;
}
.importantinformation{
  background-color: #fff6eb;
  border: 1px solid #fb8c00 ;
  padding: 10px;
  margin-bottom: 10px;
}
.vue-dropzone{
  min-height: 300px;
  background-color: #f6f6f6;
}
.dz-message {
  margin: 7em 0 !important;
}
</style>
